import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import { HeaderSmall } from '../Text';

const Row = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 0.5rem;
`;

const Text = styled(HeaderSmall)`
  padding-left: 0.5rem;
`;

interface IconTextProps {
  children?: React.ReactNode;
  icon: string;
  color?: string;
  extraPadding?: boolean;
}

function IconText({
  icon,
  children,
  color,
  extraPadding = false,
  ...props
}: IconTextProps) {
  return (
    <Row {...props}>
      <Icon name={icon} color={color} paddingTop={extraPadding ? 3 : 0} />
      <Text color={color}>{children}</Text>
    </Row>
  );
}

export default IconText;
